import {Component, inject} from '@angular/core';
import {Observable} from 'rxjs';
import { KeyValue, AsyncPipe } from '@angular/common';
import {CrmDataService} from '../../crm-data.service';
import {map} from 'rxjs/operators';
import {notNullOrUndefined} from '../../rxjs/notNullOrUndefined';
import { MatDialogTitle, MatDialogContent, MatDialogClose, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatIconButton, MatButton } from '@angular/material/button';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatIcon } from '@angular/material/icon';
import { LoaderComponent } from '../loader/loader.component';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'nbd-user-keywords',
    templateUrl: './user-keywords.component.html',
    styleUrls: ['./user-keywords.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatIconButton, MatDialogClose, CdkCopyToClipboard, MatIcon, LoaderComponent, MatDialogActions, MatButton, AsyncPipe, TranslatePipe]
})
export class UserKeywordsComponent {
  private crm = inject(CrmDataService);


  keywords$: Observable<KeyValue<string, string>[]>;

  constructor() {
    this.keywords$ = this.crm.getTableConfig('users').pipe(
      notNullOrUndefined(),
      map((config) => config.map(c => ({
        key: c.displayName,
        value: c.columnName
      })))
    );
  }
}
